module.exports = __webpack_public_path__ + "static/media/setting-icon.f90e8246.svg";